import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const INTERVIEW_QUESTIONS_BASE_URL = import.meta.env
  .VITE_TEST_INTERVIEW_QUESTIONS_BASE_URL;

export type Company = {
  id: string;
  name: string;
  slug: string;
  questionCount: number;
  createdAt: string;
};

type page = {
  size: number;
  number: number;
  totalElements: number;
  totalPages: number;
};

export type Question = {
  id: string;
  text: string;
  category: string;
  interviewType: string;
  askedCompanies: string[];
  relevancyLabel: string;
  createdAt: string;
  updatedAt: string;
};

export interface GetCompaniesResponse {
  success: string;
  data: Company[];
}

export interface GetQuestionsResponse {
  success: string;
  data: {
    page: page;
    content: Question[];
  };
}

export const InterviewQuestionsApiSlice = createApi({
  reducerPath: "interviewQuestionsApi",
  baseQuery: fetchBaseQuery({ baseUrl: INTERVIEW_QUESTIONS_BASE_URL }),
  endpoints: (builder) => ({
    getCompanies: builder.query<GetCompaniesResponse, void>({
      query: () => ({
        url: "companies",
        method: "GET",
      }),
    }),
    getQuestions: builder.query<
      GetQuestionsResponse,
      { page: number; size: number; company: string }
    >({
      query: ({ page, size, company }) => ({
        url: `questions?company=${company}&page=${page}&size=${size}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetCompaniesQuery,
  useGetQuestionsQuery,
  useLazyGetQuestionsQuery,
} = InterviewQuestionsApiSlice;
